import { render, staticRenderFns } from "./MySaleman.vue?vue&type=template&id=086a4676&scoped=true&"
import script from "./MySaleman.vue?vue&type=script&lang=js&"
export * from "./MySaleman.vue?vue&type=script&lang=js&"
import style0 from "./MySaleman.vue?vue&type=style&index=0&id=086a4676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a4676",
  null
  
)

export default component.exports